import { useCallback, useEffect } from 'react';

const useAccessibleElement = ({ ariaControls, inputElementId }) => {
    const keyPressHandler = useCallback(
        e => {
            if (e.key === 'Enter') {
                e.preventDefault();
                if (e.target.getAttribute('aria-controls') === ariaControls) {
                    return document.getElementById(inputElementId).click();
                }
                if (e.target.id === inputElementId && !ariaControls) {
                    document.getElementById(inputElementId).click();
                }
            }
        },
        [ariaControls, inputElementId],
    );

    useEffect(() => {
        document.addEventListener('keypress', keyPressHandler);

        return () => {
            document.removeEventListener('keypress', keyPressHandler);
        };
    }, [keyPressHandler]);
};

export default useAccessibleElement;
